// import colors from 'vuetify/es5/util/colors'
import { mdiClose } from '@mdi/js'

export default {
  // default @nuxtjs/vuetify config
  // For options, see https://github.com/nuxt-community/vuetify-module#defaultassets
  // breakpoint: {},
  // lang: {},
  // rtl: true,
  // Begin custom
  icons: {
    iconfont: 'mdiSvg', // 'mdi' || 'mdiSvg' || 'md' || 'fa' || 'fa4' || 'faSvg'
    values: {
      mdiClose,
      // alias for close for use with v-text-field
      close: mdiClose
    }
  },
  // lang: {},
  // rtl: true,
  breakpoint: {
    // TODO: update to MD2 spec in v3 - 1280
    mobileBreakpoint: 1264,
    scrollBarWidth: 16,
    thresholds: {
      xs: 600,
      sm: 960,
      md: 1280,
      lg: 5000 // Ensure xl breakpoint kicks in only at at very large resolutions
    }
  },
  theme: {
    options: {
      customProperties: true,
      variations: true
    },
    dark: false,
    themes: {
      light: {
        primary: {
          base: '#ed2250'
        },
        secondary: {
          base: '#04a7cb'
        },
        'facebook-blue': {
          base: '#114796'
        },
        'twitter-blue': {
          base: '#1ecdee'
        },
        'bluesky-blue': {
          base: '#0085FF'
        },
        'whatsapp-green': {
          base: '#0AD261'
        },
        'allout-blue': {
          base: '#04a7cb'
        },
        'allout-grey': {
          base: '#4c4c4c'
        },
        'allout-lightgrey': {
          base: '#e2e2e2'
        }
      }
    }
  }
}
